import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";
import { VerifyPhoneForm } from "components/forms";

const VerifyPhoneModal = ({
  isOpen = true,
  onClose,
  setIsVerfied,
  setError,
}) => {
  const handleVerificationError = (verfiy, errorMessage) => {
    console.log({ verfiy, errorMessage });
    setIsVerfied(verfiy);
    setError(errorMessage);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 flex z-50 dark:bg-[#1467B0B5] md:justify-center md:items-center bg-black bg-opacity-50 justify-end items-end scroll-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="h-[300px] w-full bg-white rounded-t-3xl dark:bg-[#181818] flex flex-col justify-center items-center gap-4 relative md:w-[450px] md:rounded-3xl"
            initial={{ y: "-100%" }}
            animate={{ y: "0%" }}
            exit={{ y: "-100%", opacity: 0 }}
            transition={{
              type: "just",
              stiffness: 300,
              damping: 20,
              duration: 0.3,
            }}
          >
            <div className="flex flex-col items-center gap-4">
              <p className="text-3xl font-semibold dark:text-white">
                <span className="text-secondary">Verification</span> Code
              </p>
              <p className="text-[#6F6C90] dark:text-gray-300 w-80 text-center">
                We have sent the verification code to your phone number.
              </p>
              <VerifyPhoneForm
                onClose={onClose}
                // setError={setError} // Pass setFieldError to form
                handleVerificationError={handleVerificationError} // Handle error message
              />
            </div>
            <div
              className="absolute right-4 top-4 cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon size="size-16" className="dark:text-white" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VerifyPhoneModal;
